<script setup>
import { defineProps } from 'vue';
import SearchBar from "@/components/Search/SearchBar.vue";

defineProps(['url', 'searchActive']);
</script>

<template>
  <div class="section-card">
    <div class="section-card-header">
      <h2><slot name="header"/></h2>
      <SearchBar :url="url" v-if="searchActive"/>
    </div>
    <slot/>
  </div>
</template>

<style scoped lang="scss">
.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 16px 0;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}
</style>